/* eslint-disable no-unused-vars */
import React from 'react'
import Team from './Team';
import Hero from './Hero';


import Footer from '../Footer';
import Navbar from '../Navbar';

function AboutPage() {
    return ( 
        <>
        <Hero />
        <Team />
        
        </>
     );
}

export default AboutPage;